import * as React from 'react';
import { compose, setDisplayName, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { WarningTriangle } from 'ui/shapes';

export type OwnProps = {
    text?: string | null;
    textKey?: string;
    style?: object;
    size?: string;
};

export const RawWarningMessage = ({ text, textKey = '', t, size = '1em', styles }: OwnProps & TranslateProps & OemProps) =>
    <div
        className="warning-message"
        style={ styles.container }
    >
        <WarningTriangle
            width={ size }
            height={ size }
            style={ styles.symbol }
        />
        <span
            style={ styles.message }
        >
            { text || t(textKey) }
        </span>
    </div>
;

export const WarningMessage = compose<OwnProps & TranslateProps & OemProps, OwnProps>(
    setDisplayName('WarningMessage'),
    skin,
    translate(),
    withProps(({ style, styles }: OwnProps & OemProps) => ({
        styles: {
            ...styles,
            container: {
                ...styles.Warning,
                ...style,
                textShadow: '1px 1px 1px rgba(0,0,0,.5)',
            },
            symbol: {
                fill: styles.Warning.color,
                verticalAlign: 'middle',
            },
            message: {
                marginLeft: '.5em',
                verticalAlign: 'middle',
            },
        },
    })),
)(RawWarningMessage);



// WEBPACK FOOTER //
// ./src/ui/shared/WarningMessage.tsx